/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardContentDeleteController',BoardContentDeleteController);

    BoardContentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Content'];

    function BoardContentDeleteController($uibModalInstance, entity, Content) {
        var vm = this;

        vm.content = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Content.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
